import { ReactElement, ReactNode } from "react";
import { LucideIcon } from "lucide-react";

import { Row, SheetSectionContainer, SheetSectionHeader } from "@/components";

export const SheetResourcesWrapper = ({
  children,
  containerClasses,
  headerControls,
  icon,
  isEmpty,
  title,
  titleActions,
}: {
  children: ReactElement;
  containerClasses?: string;
  headerControls?: ReactElement;
  icon?: LucideIcon;
  isEmpty: boolean;
  title: string;
  titleActions?: ReactNode;
}) => (
  <SheetSectionContainer className={containerClasses}>
    <Row className="items-center justify-between">
      <SheetSectionHeader icon={icon} isEmpty={isEmpty} title={title} />
      {titleActions ?? headerControls}
    </Row>
    {children}
  </SheetSectionContainer>
);
